// extracted by mini-css-extract-plugin
module.exports = {"container":"UserTestimonialSection_container__a4Pyd"};